import React from 'react';
import { Spaces } from '../../../../api/api-spaces';
import * as types from '../constants/action-types';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

const errorComponent = <FormattedMessage id="hosting.space.error_message" defaultMessage="Something went wrong. Please try again." />;

export function fetchSpaceRequest () {
  return {
    type: types.SPACE_FETCH_REQUEST
  };
}

export function fetchSpaceSuccess (data) {
  return {
    type: types.SPACE_FETCH_SUCCESS,
    data
  };
}

function fetchSpaceFailure (fetchError) {
  return {
    type: types.SPACE_FETCH_FAILURE,
    fetchError
  };
}

export function fetchCompletionStatusRequest () {
  return {
    type: types.SPACE_COMPLETION_STATUS_FETCH_REQUEST
  };
}

export function fetchCompletionStatusSuccess (data) {
  return {
    type: types.SPACE_COMPLETION_STATUS_FETCH_SUCCESS,
    completionStatusData: data
  };
}

export function fetchCompletionStatusFailure (fetchError) {
  return {
    type: types.SPACE_COMPLETION_STATUS_FETCH_FAILURE,
    fetchError
  };
}

export function fetchSpaceCountryStatusRequest () {
  return {
    type: types.SPACE_COUNTRY_STATUS_FETCH_REQUEST
  };
}

export function fetchSpaceCountryStatusSuccess (data) {
  return {
    type: types.SPACE_COUNTRY_STATUS_FETCH_SUCCESS,
    countryStatus: data
  };
}

export function fetchSpaceCountryStatusFailure (fetchError) {
  return {
    type: types.SPACE_COUNTRY_STATUS_FETCH_FAILURE,
    fetchError
  };
}

export function updateSpaceRequest () {
  return {
    type: types.SPACE_UPDATE_REQUEST
  };
}

export function updateSpaceSuccess (data) {
  return {
    type: types.SPACE_UPDATE_SUCCESS,
    data: data.space
  };
}

function updateSpaceFailure (fetchError) {
  return {
    type: types.SPACE_UPDATE_FAILURE,
    fetchError
  };
}

function createSpaceRequest () {
  return {
    type: types.SPACE_CREATE_REQUEST
  };
}

function createSpaceSuccess (data) {
  return {
    type: types.SPACE_CREATE_SUCCESS,
    data: data.space
  };
}

function createSpaceFailure (fetchError) {
  return {
    type: types.SPACE_CREATE_FAILURE,
    fetchError
  };
}

function fetchFaqSuccess ({ data }) {
  return {
    type: types.SPACE_FETCH_FAQ_SUCCESS,
    data
  };
}

function clearSpaceData () {
  return {
    type: types.SPACE_CLEAR_STORE,
    data: {}
  };
}

export function updateFaqSuccess (data) {
  return {
    type: types.SPACE_UPDATE_FAQ_SUCCESS,
    data
  };
}

export function fetchSpace (query, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchSpaceRequest());
      Spaces.read(query, accessToken, response => {
        if (200 === response.statusCode) {
          dispatch(fetchSpaceSuccess(response));

          return resolve(response);
        }

        dispatch(fetchSpaceFailure(response));
        return reject(response);
      });
    });
  };
}

export function fetchEventFaq (spaceId, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchSpaceRequest());
      Spaces.getFaq(spaceId, 'event', accessToken, (response) => {
        if (200 === response.statusCode) {
          dispatch(fetchFaqSuccess(response));
          return resolve(response);
        }
        dispatch(fetchSpaceFailure(response));
        return reject(response);
      });
    });
  };
}

export function fetchSpaceCompletionStatus (spaceId, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchCompletionStatusRequest());

      if (!spaceId) {
        dispatch(fetchCompletionStatusSuccess({
          completion_percentage: 0,
          missing: []
        }));
      }

      Spaces.read(`${spaceId}/completionStatus`, accessToken, response => {
        if (200 === response.statusCode) {
          dispatch(fetchCompletionStatusSuccess(response));

          return resolve(response);
        }

        dispatch(fetchSpaceFailure(response));
        return reject(response);
      });
    });
  };
}

export function fetchSpaceCountryStatus (ssoId, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchSpaceCountryStatusRequest());

      Spaces.read(`owner/${ssoId}/country`, accessToken, response => {
        if (200 === response.statusCode) {
          dispatch(fetchSpaceCountryStatusSuccess(response));

          return resolve(response);
        }

        dispatch(fetchSpaceCountryStatusFailure(response));
        return reject(response);
      });
    });
  };
}

export function updateSpace (id, accessToken, paylaod) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(updateSpaceRequest());
      Spaces.update(id, accessToken, paylaod, response => {
        if (200 === response.statusCode) {
          dispatch(updateSpaceSuccess(response));

          return resolve(response);
        }

        const errorMessage = get(response, 'error', errorComponent);

        dispatch(updateSpaceFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}

export function updateEventFaq (id, accessToken, payload) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(updateSpaceRequest());
      Spaces.updateFaq(id, 'event', accessToken, payload, response => {
        const error = get(response, 'amenitiesUpsert.error', null);
        if (200 === response.statusCode && !error) {
          dispatch(updateFaqSuccess(payload));
          return resolve(response);
        }

        const errorMessage = get(response, 'error', errorComponent);

        dispatch(updateSpaceFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}

export function createSpace (accessToken, paylaod) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(createSpaceRequest());
      Spaces.create(accessToken, paylaod, response => {
        if (200 === response.statusCode) {
          dispatch(createSpaceSuccess(response));

          return resolve(response);
        }

        const errorMessage = get(response, 'error', errorComponent);

        dispatch(createSpaceFailure(errorMessage));
        // Reject with the whole body, not just `errorMessage`: the address form maps
        // `error_code` and `missing` onto individual fields.
        return reject(response);
      });
    });
  };
}


export function clearSpaceStore () {
  return dispatch => {
    dispatch(clearSpaceData());
  };
}
